import { Observable, Subject } from "rxjs";
import { ICustomLegend, ILayerLegend } from "../layer-legend/models/legend-models";
export type NodeType = "child" | "root";

export interface INode {
    id: string;
    name: string;
    nodeType: NodeType;
    checked?: boolean;
    opacity?: number;
    disabled?: boolean;
    layerid?: string;
    sublayerid?: number;
    sublayerName?: string;
    partiallyChecked?: boolean;
    nodes?: INode[];
    parent?: INode;
    checkChanged: Observable<INode>;
    opacityChanged: Observable<INode>;
    legends: Observable<ILayerLegend[]>;
    customLegend: ICustomLegend;
    ready?: boolean;
    readonly?: boolean;
    someChildHasLegends: boolean;
    error?: boolean;
    type: string;
    minScale?: number;
}

export class Node implements INode {
    id: string;
    name: string;
    type: string;
    minScale?: number;
    parent: INode;
    nodes?: INode[];
    layerid?: string;
    sublayerid?: number;
    sublayerName: string;
    nodeType: NodeType;
    visible?: boolean;
    disabled?: boolean;
    partiallyChecked?: boolean;
    legends: Observable<ILayerLegend[]>;
    customLegend: ICustomLegend;
    ready?: boolean;
    opacityChanged: Observable<INode>;
    checkChanged: Observable<INode>;
    readonly?: boolean;
    childrenHasLegends: boolean;
    error?: boolean;

    private checkedValue: boolean;
    private opacityValue: number;
    private readonly checkedSubject = new Subject<INode>();
    private readonly opacitySubject = new Subject<INode>();

    get checked() {
        return this.checkedValue;
    }
    set checked(checked) {
        this.checkedValue = checked;
        this.checkedSubject.next(this);
    }

    get opacity() {
        return this.opacityValue;
    }
    set opacity(value) {
        this.opacityValue = value;
        this.opacitySubject.next(this);
    }

    constructor(parent?: INode, type?: string) {
        this.parent = parent;
        this.type = type;
        this.nodeType = "child";
        this.checkChanged = this.checkedSubject.asObservable();
        this.opacityChanged = this.opacitySubject.asObservable();
        this.error = false;
    }

    get showLegend() {
        return (this.checked || this.partiallyChecked);
    }

    get someChildHasLegends() {
        return this.nodes?.some(n => !!n.legends) || this.nodes?.some(n => n.someChildHasLegends);
    }
}
